import * as S from "./styles";

type CardWitnessProps = {
  nome: string;
  cargo: string;
  handleDelete: () => void;
};
export const CardWitness = ({
  cargo,
  handleDelete,
  nome,
}: CardWitnessProps) => {
  return (
    <S.CardWitnessStyles>
      <p>
        Nome: <span>{nome}</span>
      </p>

      <p>
        Cargo: <span>{cargo}</span>
      </p>

      <div onClick={handleDelete}>
        <img src="/assets/imgs/icon-delete.svg" alt="icone lixeira" />
      </div>
    </S.CardWitnessStyles>
  );
};
